export default "__VITE_ASSET__5dd42506__"